const prefix = 'features/common/flash';

export const ADD_MESSAGE = `${prefix}/ADD_MESSAGE`;
export const REMOVE_MESSAGE = `${prefix}/DISMISS_MESSAGE`;
export const REMOVE_ALL = `${prefix}/REMOVE_ALL`;



// WEBPACK FOOTER //
// ./src/store/features/common/flash/action-types.js